module.exports = "/images/chevron-down-grey.svg?55b0c31901b90f2372b706ab3631a456";